import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTransformOptions } from 'Core/hooks';
import { TextEditor } from 'Core/components/editor';
import CustomPropTypes from 'CustomPropTypes';
import { selectLabelsList } from './store/selectors';
import { ProductionService } from '../../service/api/production-service';
// import { fetchStatuses } from '../../core/redux/status/slice';
// import { fetchLabels } from '../../core/redux/label/slice';

const initData = {
  // id: "0",
  userId: "",
  customerName: "",
  // customerNumber: "",
  // customerIdExt: "",
  location: "",
  status: "",
  customerShortName: "",
  label: "",
  labelPrinter: 0,
  documentPrinter: 0,
  isDynamicShippingDocument: false,
  domain: "",
};

const CustomersAddEditForm = ({ data, onChanges, id }) => {

  const statusesList = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' }
  ]
  const labelsList = useSelector(selectLabelsList);
  // [
  //   { label: 'CP-GLOBAL.trdp', value: 'CP-GLOBAL.trdp' },
  //   { label: 'CP-IRVIN.trdp', value: 'CP-IRVIN.trdp' }
  // ]
  const labelOptions = useTransformOptions(labelsList, 'id', 'labelName', '', 'Select Label');
  const statusesOptions = useTransformOptions(statusesList, 'value', 'label', '', 'Select Status');
const [printerOptions, setPrinterOptions] = useState([]);

  const [formData, setFormData] = useState(data ? data : initData);

  const updateFormField = (fieldName, value) => {
    setFormData(prevData => ({
      ...prevData,
      [fieldName]: value,
    }));
    onChanges({ ...formData, [fieldName]: value });
  };

  const expeditedList = [
    { value: 'No', label: 'No' },
    { value: 'Yes', label: 'Yes' },
  ];

  const printerDropdownOptions = printerOptions.map(p => ({
  label: p.printerName,   
  value: p.printerId,     
}));

  useEffect(() => {
  const fetchPrinterOptions = async () => {
    try {
      const response = await ProductionService.getPrinters(); 
      if (response.status === 200) {
        setPrinterOptions(response.response || []);
      }
    } catch (error) {
      console.error('Failed to fetch printer options:', error);
    }
  };

  fetchPrinterOptions();
}, []);

  return (
    <>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Customer Name <span className="text-danger">*</span>
            </label>
            <input
              name="customerName"
              type="text"
              className="form-control"
              value={formData.customerName}
              onChange={e => updateFormField('customerName', e.target.value)}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Location <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.location}
                onChange={e => updateFormField('location', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Status <span className="text-danger">*</span>
            </label>
            <select
              value={formData.status}
              onChange={e => updateFormField('status', e.target.value)}
              className="form-control"
              required
            >
              {statusesOptions.map(option => (
                <option key={option.label} value={option.label}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Label
            </label>
            <select
              value={formData.label}
              onChange={e => updateFormField('label', e.target.value)}
              className="form-control"
              required
            >
              {labelOptions.map(option => (
                <option key={option.label} value={option.label}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Customer Short Name <span className="text-danger">*</span>
            </label>
            <input
              name="customerShortName"
              type="text"
              className="form-control"
              maxlength="10"
              value={formData.customerShortName}
              onChange={e => updateFormField('customerShortName', e.target.value)}
            />
          </div>
        </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
             Label Printer
            </label>
              <select
              value={formData.labelPrinter}
              onChange={e => updateFormField('labelPrinter',Number(e.target.value))}
              className="form-control"
              required
            >
           <option value="">Select Label Printer</option>
      {printerDropdownOptions.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
</div>
          <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Document Printer
            </label>
             <select
              value={formData.documentPrinter}
              onChange={e => updateFormField('documentPrinter',Number(e.target.value))}
              className="form-control"
              required
            >
          <option value="">Select Document Printer</option>
      {printerDropdownOptions.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
</div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="input-blocks">
              <label className="form-label d-block mb-2">Options</label>
              <div className="form-check" style={{ marginTop: '8px' }}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isDynamicShippingDocument"
                  checked={formData.isDynamicShippingDocument || false}
                  onChange={e => updateFormField('isDynamicShippingDocument', e.target.checked)}
                  style={{ 
                    transform: 'scale(1.8)', 
                    marginRight: '12px', 
                    width: '20px', 
                    height: '20px',
                    accentColor: '#007bff'
                  }}
                />
                <label className="form-check-label" htmlFor="isDynamicShippingDocument" style={{ fontSize: '15px', fontWeight: '500', lineHeight: '1.5' }}>
                  Is Dynamic Shipping Document
                </label>
              </div>
            </div>
          </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Domain
            </label>
            <input
              name="domain"
              type="text"
              className="form-control"
              value={formData.domain || ""}
              onChange={e => updateFormField('domain', e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

CustomersAddEditForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.object,
  onChanges: PropTypes.func,
};

export default CustomersAddEditForm;
